var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-us-container"},[_c('router-link',{attrs:{"to":{path: '/about'}}},[_c('div',{staticClass:"wrap"},[_c('e-title',{attrs:{"content":_vm.title.field1 || ''}}),_c('img',{attrs:{"src":_vm.item.href}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }